export const getGiCarPageVersion = (query: any) => {
  const v2Param = Array.isArray(query?.v2) ? query.v2[0] : query?.v2
  const isV2 = v2Param !== undefined && v2Param !== 'false' && v2Param !== '0'
  if (isV2) return 'V2'
  const v3Param = Array.isArray(query?.v3) ? query.v3[0] : query?.v3
  const isV3 = v3Param !== undefined && v3Param !== 'false' && v3Param !== '0'
  if (isV3) return 'V3'
  return 'V1'
}

export const isGiCarPageV1 = (version?: string) => version === 'V1' || !version
